import { render, staticRenderFns } from "./ReceiptStatus.vue?vue&type=template&id=85818346&"
import script from "./ReceiptStatus.vue?vue&type=script&lang=js&"
export * from "./ReceiptStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports